import type { Paginator as PrimePaginator } from "primereact/paginator";
import type { ForwardedRef } from "react";

import { TABLE_ROWS_OPTIONS } from "../../hooks/constants";
import { mergePt } from "../../utils/merge-pt";
import { withDefaults } from "../../utils/with-defaults";
import { PAGINATOR_LABEL, PAGINATOR_REPORT, PAGINATOR_ROWS_LABEL } from "./messages";
import { HUB_TEMPLATE } from "./paginator.constants";
import styles from "./paginator.module.scss";
import type { PaginatorProps, PaginatorViewModel } from "./types-paginator";

/**
 * ViewModel do Paginator: padrões do Hub (template, relatório, linhas por página, rótulos em pt-BR) sob as props da tela e
 * o `data-testid` de cada controle derivado do `data-testid` da raiz; sem JSX.
 */
export function usePaginator(
  { pt, className, ...props }: PaginatorProps,
  ref: ForwardedRef<PrimePaginator>,
): PaginatorViewModel {
  const testId = (props as { "data-testid"?: string })["data-testid"];
  const partTestId = (part: string) => (testId ? `${testId}-${part}` : undefined);

  return {
    paginatorRef: ref,
    className,
    paginatorProps: withDefaults(
      {
        role: "navigation",
        "aria-label": PAGINATOR_LABEL,
        template: HUB_TEMPLATE,
        currentPageReportTemplate: PAGINATOR_REPORT,
        rowsPerPageOptions: TABLE_ROWS_OPTIONS,
      },
      props,
    ),
    pt: mergePt(
      {
        firstPageButton: { "data-testid": partTestId("primeira") },
        prevPageButton: { "data-testid": partTestId("anterior") },
        nextPageButton: { "data-testid": partTestId("proxima") },
        lastPageButton: { "data-testid": partTestId("ultima") },
        current: { "data-testid": partTestId("relatorio") },
        RPPDropdown: {
          root: { "data-testid": partTestId("linhas") },
          // `rowsLabel`: a `line-height` do label acompanha a altura de 40 do campo (ver o módulo).
          input: { "aria-label": PAGINATOR_ROWS_LABEL, className: styles.rowsLabel },
        },
      },
      pt,
    ),
  };
}
